export const Resource = {
  // ROOT RESOURCES
  Tenants: 'Tenants',
  Admin: 'Admin',
  Hangfire: 'Hangfire',
  Users: 'Users',
  UserRoles: 'UserRoles',
  Roles: 'Roles',
  RoleClaims: 'RoleClaims',
  AuditLogs: 'AuditLogs',
  ContactRequests: 'ContactRequests',
  System: 'System',

  // Basic
  Dashboard: 'Dashboard',
  Messenger: 'Messenger',
  DriveFiles: 'DriveFiles',
  Reminders: 'Reminders',
  Settings: 'Settings',

  // Webpage and blog resources
  Cms: 'Cms',
  Website: 'Website',
  Blog: 'Blog',
  IdCard: 'IdCard',
  PublicProfile: 'PublicProfile',

  // WMS / CRM
  MyCompany: 'MyCompany',
  Offer: 'Offer',
  Order: 'Order',
  ServiceOrders: 'ServiceOrders',
  OrderStatuses: 'OrderStatuses',
  OrderPriorities: 'OrderPriorities',
  OrderTags: 'OrderTags',
  Inventory: 'Inventory',
  Products: 'Products',
  Services: 'Services',
  Categories: 'Categories',
  CalendarPersonal: 'CalendarPersonal',
  CalendarCompany: 'CalendarCompany',
  Brands: 'Brands',
  Customers: 'Customers',
  Employees: 'Employees',
  EmployeeAccounts: 'EmployeeAccounts',
  Positions: 'Positions',
  CustomersNotes: 'CustomersNotes',
  Analytics: 'Analytics',
  Invoicing: 'Invoicing'
} as const;

export type ResourceType = (typeof Resource)[keyof typeof Resource];
